import { Row, Skeleton, Cell } from '@fs/zion-ui'
import React from 'react'
import { Person } from '@fs/zion-person'
import { ContributionValue, ViewChangeButton, ContributionDate } from '@fs/zion-tree-contributions'

export const Column1Skeleton = () => <Skeleton.Paragraph maxWidth={150} size="sm" />

export const Column1 = ({ contribution, contributionsPersons }) => {
  const personId =
    contribution.personId || // person
    contribution.person1Id || // association relationship
    contribution.childId || // parent-child relationship
    contribution.spouse1Id // couple relationship

  if (!personId) return null

  return <Person componentSize="sm" avatarSize="bigger" id={personId} personObj={contributionsPersons?.[personId]} />
}

export const Column2Skeleton = () => (
  <>
    <div>
      <Skeleton.Paragraph maxWidth={100} size="sm" />
    </div>
    <div>
      <Skeleton.Paragraph maxWidth={175} size="sm" />
    </div>
    <Skeleton.Paragraph maxWidth={150} size="sm" />
  </>
)

export const Column2 = ({ contribution, contributionsPersons }) => (
  <ContributionValue
    contribution={contribution}
    contributionsPersons={contributionsPersons ?? {}}
    LoadingComponent={<Column2Skeleton />}
  />
)

export const Column3Skeleton = () => (
  <Row gutters="xs" wrap guttersY="nano">
    <Cell growX>
      <Skeleton.Paragraph maxWidth={160} size="xs" />
      <Skeleton.Chip />
    </Cell>
    <Skeleton.Button minWidth={100} data-testid="row-skeleton-button" noShrinkX />
  </Row>
)

export const Column3 = ({ contribution }) => (
  <Row gutters="xs" wrap guttersY="nano">
    <ContributionDate contribution={contribution} growX />
    {/* eslint-disable-next-line test-selectors/button -- NA */}
    <ViewChangeButton contribution={contribution} noShrinkX />
  </Row>
)
